import React, { useMemo, useState } from "react";
import { Card, DataTable, hasActiveFilters, useFilterSortPagination, } from "@sscs/ui";
import { getQueryStatus, sortItems } from "@sscs/utils";
import { useGetComponentNetworkingQuery } from "../../services/fileBrowser.api";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import Filter from "./filter/Filter";
import NetworkingRow from "./networkingRow/NetworkingRow";
import { filterNetworking, initFilter, initSort, specialCasesForSorting, } from "./utils";
const COLUMNS = [
    { id: "info", label: "Info", width: "70px" },
    {
        id: "value",
        label: "Value",
        sortProperty: "value",
        sortId: "value-sort",
        width: "100%",
    },
    {
        id: "threat",
        label: "Threat name",
        sortProperty: "classification_result",
        sortId: "threat-name-sort",
        width: "300px",
    },
    { id: "tags", label: "Tags", width: "300px" },
];
const Networking = () => {
    const { fileId, reportId } = useGetFileAndReportId();
    const [focusedRow, setFocusedRow] = useState(null);
    const { filter, sort, pagination, handleFilterChange, handleSortChange, handlePaginationChange, } = useFilterSortPagination(initFilter, initSort);
    const { data = { networking: [] }, isLoading, isFetching, isError, error, } = useGetComponentNetworkingQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const tags = useMemo(() => {
        const tags = new Set();
        data.networking.forEach((uri) => {
            uri.tags.forEach((tag) => {
                tags.add(tag);
            });
        });
        return Array.from(tags);
    }, [data.networking]);
    const filteredData = useMemo(() => filterNetworking(data.networking, filter), [data.networking, filter]);
    const sortedData = useMemo(() => {
        return sortItems(filteredData, {
            property: sort.property,
            reverse: sort.reverse,
        }, specialCasesForSorting);
    }, [filteredData, sort]);
    const paginatedData = useMemo(() => {
        return sortedData.slice((pagination.currentPage - 1) * pagination.itemsPerPage, pagination.currentPage * pagination.itemsPerPage);
    }, [sortedData, pagination]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card.Filters, { found: {
                id: "clear-all-filters",
                count: sortedData.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => handleFilterChange(initFilter),
            } },
            React.createElement(Filter, { filter: filter, tags: tags, onFilterChange: handleFilterChange })),
        React.createElement(DataTable, { chrome: "plain", columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                subject: "URIs",
                filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => handleFilterChange(initFilter),
                },
            }, status: getQueryStatus({
                data,
                isLoading,
                isFetching,
                isError,
                error,
            }), pagination: {
                id: "pagination",
                itemCount: sortedData.length,
                pagination,
                onChange: handlePaginationChange,
            } }, paginatedData.map((uri, index) => (React.createElement(NetworkingRow, { key: uri.id, networking: uri, rowIndex: index, onClick: () => setFocusedRow(uri.id), focused: focusedRow === uri.id, searchRegex: filter.searchRegex }))))));
};
export default Networking;
//# sourceMappingURL=Networking.js.map